// src/components/CalendarCallback.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

const CalendarCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      
      if (code) {
        try {
          await api.post('/api/calendar/authorize', { code });
          navigate('/calendar');
        } catch (error) {
          console.error('Calendar authorization failed:', error);
          navigate('/calendar?error=auth_failed');
        }
      } else {
        navigate('/calendar?error=no_code');
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <h2 className="text-xl font-semibold mb-2">Authorizing Calendar...</h2>
        <p className="text-gray-600">Please wait while we complete the setup.</p>
      </div>
    </div>
  );
};

export default CalendarCallback;
